import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'

import { CarouselVariantEnum } from '../Carousel/Carousel'

import CarrouselSlide from './CarrouselSlide/CarrouselSlide'
import CKEditorContent from '../CKEditorContent/CKEditorContent'
import {
  StyledCarousel,
  StyledCarrouselBlock,
  StyledInformations,
  StyledTitle,
} from './CarrouselBlock.styled'
import CarrouselPopin from './CarrouselPopin/CarrouselPopin'

const CarrouselBlock = (props) => {
  const { items, title } = props

  const [currentSlide, setCurrentSlide] = useState(0)
  const [isPopinOpen, setIsPopinOpen] = useState(false)

  const slides = useMemo(
    () =>
      items.map((item, index) => (
        <CarrouselSlide
          {...item.smallImage}
          hasExpandButton={true}
          setIsPopinOpen={setIsPopinOpen}
          key={item.title + index}
        />
      )),
    []
  )

  const informations = useMemo(
    () =>
      items.map((item, index) => (
        <StyledInformations
          $isActive={index === currentSlide}
          key={item.title + index}
        >
          <StyledTitle>{item.title}</StyledTitle>
          {item?.blocText?.content && (
            <CKEditorContent html={item.blocText.content} />
          )}
        </StyledInformations>
      )),
    [currentSlide]
  )

  return (
    <StyledCarrouselBlock>
      <StyledCarousel
        onChange={setCurrentSlide}
        title={title}
        variant={CarouselVariantEnum.media}
      >
        {slides}
      </StyledCarousel>
      <div>{informations}</div>
      {isPopinOpen && (
        <CarrouselPopin
          initialSlide={currentSlide}
          items={items}
          setIsPopinOpen={setIsPopinOpen}
        />
      )}
    </StyledCarrouselBlock>
  )
}

CarrouselBlock.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object).isRequired,
  title: PropTypes.string.isRequired,
}

export default CarrouselBlock
